"use strict";
exports.__esModule = true;
var getConfig_1 = require("../config/getConfig");
var getValue_1 = require("./getValue");
function getSchemaValue(_a, config) {
    var $ = _a.$, el = _a.el;
    var value = Object.keys(config).reduce(function (values, key) {
        var currentRawConfig = getConfig_1["default"]({ $: $, el: el }, config[key]);
        values[key] = getValue_1["default"]({ $: $, el: el }, currentRawConfig);
        return values;
    }, {});
    return value;
}
exports["default"] = getSchemaValue;
